import { render, staticRenderFns } from "./PostHashtagsSettings.vue?vue&type=template&id=380e2652&scoped=true&"
import script from "./PostHashtagsSettings.vue?vue&type=script&lang=ts&"
export * from "./PostHashtagsSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380e2652",
  null
  
)

export default component.exports